import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Header from './Header';
import Footer from './Footer';
import './EmbedPage.css';

interface EmbedPageProps {
  /** Ključ prevoda za naslov i uvod (npr. 'parents.schedule'). */
  i18nKey: string;
  /** Adresa aplikacije koja se prikazuje u iframe-u. */
  src: string;
}

/** Stranica koja ugrađuje spoljnu aplikaciju kluba (raspored, prevoz) u sajt. */
const EmbedPage: React.FC<EmbedPageProps> = ({ i18nKey, src }) => {
  const { t } = useLanguage();
  const title = t(`${i18nKey}.title`);

  return (
    <div className="App App--cup embed-page">
      <Header />
      <main className="embed-page__main">
        {/* Naslov samo za čitače ekrana i pretraživače — aplikacija ima svoje zaglavlje */}
        <h1 className="embed-page__sr-title">{title}</h1>
        <div className="embed-page__frame-wrap">
          <iframe
            className="embed-page__frame"
            src={src}
            title={title}
            loading="eager"
            referrerPolicy="no-referrer-when-downgrade"
            allow="clipboard-write"
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default EmbedPage;
